import { useState, useEffect } from "react";
import { apiUrl } from "utils/api";

const useTopCatalogueData = () => {
  const [topCatalogues, setCatalogues] = useState([]);
  const [loadingTopCatalogue, setLoading] = useState(true);
  const [errorTopCatalogue, setError] = useState(null);

  useEffect(() => {
    const fetchTopCatalogue = async () => {
      try {
        const response = await fetch(apiUrl("getTopCatalogue"));
        // const response = await fetch("/api/getCatalogue");
        if (!response.ok) {
          throw new Error("Failed to fetch top catalogue");
        }
        const data = await response.json();
        setCatalogues(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTopCatalogue();
  }, []);

  return { topCatalogues, loadingTopCatalogue, errorTopCatalogue };
};

export default useTopCatalogueData;
